export default __webpack_public_path__ + "static/media/Latinotype - Branding-Medium.032a7b67.otf";